import React from 'react';

interface TimeInputProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  error?: string;
}

const TimeInput: React.FC<TimeInputProps> = ({
  label,
  value,
  onChange,
  required,
  error,
}) => {
  return (
    <div className='flex w-full flex-col gap-[8px]'>
      <label className='w-fit text-[20px] font-medium leading-[26px]'>
        {label}
      </label>
      <input
        type='time'
        className={`h-[72px] w-full rounded-2xl border border-solid border-[#E1E1E1] px-6 text-xl font-normal leading-[26px] outline-none ${
          error ? 'border-red-500' : ''
        }`}
        value={value}
        onChange={onChange}
        required={required}
        placeholder='00:00'
      />
      {error && <span className='text-red-500 mt-1 text-sm'>{error}</span>}
    </div>
  );
};

export default TimeInput;
